import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useScreenAuth from './useScreenAuth';

const PrivateRouteScreen = ({ children, requiredViews = [] }) => {
  const location = useLocation();
  const { isAuthenticated, views, isLoading } = useScreenAuth();

  if (isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/screens/login" replace state={{ from: location }} />;
  }

  if (requiredViews.length > 0) {
    const hasAccess = requiredViews.every((view) => views.includes(view));
    if (!hasAccess) {
      return <Navigate to="/screens/login" replace state={{ from: location }} />;
    }
  }

  return children;
};

export default PrivateRouteScreen;
